<template>
  <div class="p-0" >   
    <h1 class="mb-5 mt-5" id="entries">{{$t('Faq.Entries')}}</h1>
    <app-accordion
      class="mb-3 p-3 border"
      v-for="(item, index) in faqListentries"
      :key="index"
    >
      <template v-slot:title>
        <p class="font-semibold" v-html="$t(index + '.question')"></p>
      </template>
      <template v-slot:content>
        <p v-html="$t(index + '.answer')"></p>
      </template>
      {{ item }}
    </app-accordion>

    <h1 class="mb-5 mt-5" id="search">{{$t('Faq.Search')}}</h1>
    <app-accordion
      class="mb-3 p-3 border"
      v-for="(item, index) in faqListsearch"
      :key="index"
    >
      <template v-slot:title>
        <p class="font-semibold" v-html="$t(index + '.question')"></p>
      </template>
      <template v-slot:content>
        <p v-html="$t(index + '.answer')"></p>
      </template>
      {{ item }}
    </app-accordion>
    
    <h1 class="mb-5 mt-5">{{$t('Faq.Prices')}}</h1>
    <app-accordion
      class="mb-3 p-3 border"
      v-for="(item, index) in faqListprices"
      :key="index"
    >
      <template v-slot:title>
        <p class="font-semibold" v-html="$t(index + '.question')"></p>
      </template>
      <template v-slot:content>
        <p v-html="$t(index + '.answer')"></p>
      </template>
      {{ item }}
    </app-accordion>
    
    <h1 class="mb-5 mt-5">{{$t('Faq.Contact')}}</h1>
    <app-accordion
      class="mb-3 p-3 border"
      v-for="(item, index) in faqListcontact"
      :key="index"
    >
      <template v-slot:title>
        <p class="font-semibold" v-html="$t(index + '.question')"></p>
      </template>
      <template v-slot:content>
        <p v-html="$t(index + '.answer')"></p>
      </template>
      {{ item }}
    </app-accordion>
    
  </div>
</template>

<script>
import { scrollToanker } from "../utils/ScrollAnker.js";
import AppAccordion from "../components/FaqAccordion.vue";
import faqcontact from "../locales/de.faq.contact.json";
import faqentries from "../locales/de.faq.entries.json";
import faqqprices from "../locales/de.faq.prices.json";
import faqsearch from "../locales/de.faq.search.json";

export default {
  name: "App",
  data() {
    return {
      faqListcontact: faqcontact,
      faqListentries: faqentries,
      faqListprices: faqqprices,
      faqListsearch: faqsearch,        
    };
  },
  components: {
    AppAccordion,
  },
  mounted() {
    scrollToanker();
  },   
};
</script>